import { render, staticRenderFns } from "./ModalUserRegistered.vue?vue&type=template&id=1fff7764&"
import script from "./ModalUserRegistered.vue?vue&type=script&lang=js&"
export * from "./ModalUserRegistered.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserRegistered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports